/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Configure_Batch_Transcription_JobsInputs */

const en_configure_batch_transcription_jobs = /** @type {(inputs: Configure_Batch_Transcription_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure and submit batch transcription jobs`)
};

const fr_configure_batch_transcription_jobs = /** @type {(inputs: Configure_Batch_Transcription_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurer et soumettre des tâches de transcription par lot`)
};

const de_configure_batch_transcription_jobs = /** @type {(inputs: Configure_Batch_Transcription_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfigurieren und Übermitteln von Stapeltranskriptionsaufträgen`)
};

const it_configure_batch_transcription_jobs = /** @type {(inputs: Configure_Batch_Transcription_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurare e inviare lavori di trascrizione in batch`)
};

const ru_configure_batch_transcription_jobs = /** @type {(inputs: Configure_Batch_Transcription_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройка и отправка заданий пакетной транскрипции.`)
};

const es_configure_batch_transcription_jobs = /** @type {(inputs: Configure_Batch_Transcription_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurar y enviar trabajos de transcripción por lotes`)
};

const zh_cn2_configure_batch_transcription_jobs = /** @type {(inputs: Configure_Batch_Transcription_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配置并提交批量转录作业`)
};

const ja_configure_batch_transcription_jobs = /** @type {(inputs: Configure_Batch_Transcription_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バッチ転写ジョブの設定と送信`)
};

const hi_configure_batch_transcription_jobs = /** @type {(inputs: Configure_Batch_Transcription_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बैच ट्रांसक्रिप्शन जॉब्स को कॉन्फ़िगर करें और सबमिट करें`)
};

const pt_pt2_configure_batch_transcription_jobs = /** @type {(inputs: Configure_Batch_Transcription_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure e envie trabalhos de transcrição em lote.`)
};

/**
* | output |
* | --- |
* | "Configure and submit batch transcription jobs" |
*
* @param {Configure_Batch_Transcription_JobsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const configure_batch_transcription_jobs = /** @type {((inputs?: Configure_Batch_Transcription_JobsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Configure_Batch_Transcription_JobsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_configure_batch_transcription_jobs(inputs)
	if (locale === "de") return de_configure_batch_transcription_jobs(inputs)
	if (locale === "it") return it_configure_batch_transcription_jobs(inputs)
	if (locale === "ru") return ru_configure_batch_transcription_jobs(inputs)
	if (locale === "es") return es_configure_batch_transcription_jobs(inputs)
	if (locale === "zh-CN") return zh_cn2_configure_batch_transcription_jobs(inputs)
	if (locale === "ja") return ja_configure_batch_transcription_jobs(inputs)
	if (locale === "hi") return hi_configure_batch_transcription_jobs(inputs)
	if (locale === "pt-PT") return pt_pt2_configure_batch_transcription_jobs(inputs)
	return en_configure_batch_transcription_jobs(inputs)
});